/**
 * Release history shown in Help → What's New.
 *
 * This is the single place the app states its version: bump APP_VERSION and add
 * an entry here as part of shipping, so the note in Help never drifts from what
 * is actually deployed. Entries are newest-first and written for the people
 * using the app — user-visible changes only, no internal refactors.
 */

/** The version this build reports, shown at the top of the What's New tab. */
export const APP_VERSION = '1.4.0';

/** Release channel label shown beside the version. */
export const APP_CHANNEL = 'Beta';

export const releases = [
  {
    version: '1.4.0',
    date: '13 August 2026',
    title: 'Permissions, notifications and dashboard accuracy',
    highlights: [
      'The Role Permissions matrix now grants exactly what it shows — a ticked box takes effect for that role.',
      'Notifications reach every role configured to receive them, and each notification category is recorded in the log.',
      'The User Directory tiles count the same rows the table below them lists.',
    ],
  },
  {
    version: '1.3.0',
    date: '11 August 2026',
    title: 'Central sign-in and connector accreditation',
    highlights: [
      'Sign-in, registration and password reset run through the central identity service, with a dedicated admin console for account management.',
      'Bot protection is active on the sign-in and registration forms.',
      'The connector accreditation badge reads from one source, so the profile, directory and review screens always agree.',
      'Connector IDs are issued from the highest ID in use, ending duplicate-ID failures on sign-up.',
      'Approved loan amount is visible in the connector’s referral detail view.',
    ],
  },
  {
    version: '1.2.0',
    date: '31 July 2026',
    title: 'eKYC and referral corrections',
    highlights: [
      'Government ID capture now takes the front and back of the ID; passports and other IDs route to manual review instead.',
      'Mobile verification uses a real one-time passcode sent by SMS.',
      'Uploaded IDs can be viewed and downloaded during accreditation review.',
      'Staff can return a referral to the connector for correction, and the connector sees exactly what needs fixing.',
    ],
  },
  {
    version: '1.1.0',
    date: '29 July 2026',
    title: 'Mobile experience and connector commissions',
    highlights: [
      'Connectors get a dedicated Commissions page with earned, pending and payout detail.',
      'A broad phone-layout pass across referrals, profile, notifications, dashboards and the group console.',
      'Notification links open the referral they refer to.',
    ],
  },
  {
    version: '1.0.0',
    date: '15 July 2026',
    title: 'First beta release',
    highlights: [
      'End-to-end referral lifecycle from connector submission through intake, branch routing, RM assignment and release.',
      'Commission processing, finance export and payout release.',
      'Connector onboarding with KYC and accreditation review.',
      'Per-company administration, branches, product catalog and tenant branding, plus the group console for group-wide oversight.',
    ],
  },
];

export default releases;
